/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import SetPassword from '../views/SetPassword';
import MfaVerification from '../views/MfaVerification';
import AppUtils from '../../../utilities/AppUtils';
// import UserService from '../../../apiServices/UserService';
import SessionService from '../../../apiServices/SessionService';
import tokenDurations from '../../../constants/tokenDurations';


class ConfirmChangeEmail extends React.Component {

  constructor(props) {
    super(props);

    this.cancelPasswordReset = this.cancelPasswordReset.bind(this);
    this.onSubmitValidPassword = this.onSubmitValidPassword.bind(this);
    this.cancelMfaCode = this.cancelMfaCode.bind(this);
    this.submitMfaCode = this.submitMfaCode.bind(this);

    this.state = {
      password: '',
    };
  }

  onSubmitValidPassword(password) {
    if (this.props.isMfaEnabled) {
      this.setState({
        password,
      });
      return;
    }

    SessionService.changeEmail(
      this.props.token,
      password,
      tokenDurations.SHORT,
      (apiError) => {
        if (!apiError) {
          AppUtils.reloadApp();
        }
      }
    );
  }

  submitMfaCode(mfaCode) {
    SessionService.mfaChangeEmail(mfaCode, this.state.password, this.props.token, tokenDurations.LONG, (apiError) => {
      if (!apiError) {
        AppUtils.reloadApp();
      }
    });
  }

  cancelPasswordReset() {
    AppUtils.logout({}, AppUtils.reloadApp);
  }

  cancelMfaCode() {
    this.setState({
      password: '',
    });
  }

  render() {
    if (!this.state.password) {
      return (
        <SetPassword
          title="loginPwd.changeEmailTitle.text"
          onCancel={this.cancelPasswordReset}
          onSubmit={this.onSubmitValidPassword}
          allowLanguageToggle={false}
        />
      );
    } else {
      return (
        <MfaVerification
          token={this.props.token}
          submitMfaCode={this.submitMfaCode}
          cancelMfa={this.cancelMfaCode}
          clearError={() => {}}
        />
      );
    }
  }
}
ConfirmChangeEmail.propTypes = {
  token: PropTypes.string.isRequired,
  isMfaEnabled: PropTypes.bool,
};

export default ConfirmChangeEmail;
